module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 22@2x.491b6f3e.png";